import ChecklistBoard from "@/pages/hrms/ChecklistBoard";

export default function Onboarding() {
  return <ChecklistBoard type="onboarding" title="Onboarding" subtitle="Track every new hire from offer acceptance to their first day." />;
}
